// @ts-nocheck

import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';
import NotificationActions from '../NotificationActions';

const ERROR_MESSAGE = 'Failed to fetch events popularity.';
const ERROR = 'error';

const FetchEventsPopularity = new ReduxAsyncAction('FETCH_EVENTS_POPULARITY');
FetchEventsPopularity.registerRequest(async (isAgencyUser: boolean = false) => {
  if (isAgencyUser) {
    return;
  }

  try {
    const response = await dash_api.get('/v1/analytics/events');

    return response.data;
  } catch (e) {
    NotificationActions.showNotification(ERROR_MESSAGE, ERROR);
    throw e;
  }
});
export const FETCH_EVENTS_POPULARITY: any = FetchEventsPopularity.constants;
export const fetchEventsPopularity = FetchEventsPopularity.request;
